import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingPageHeader from './LandingPageHeader';
import PublicCalendar from './PublicCalendar';
import './FacilityRental.css';

function FacilityRental() {
  const navigate = useNavigate();

  const handleNav = (section) => {
    if (section === 'home') {
      navigate('/');
    } else if (section === 'waiver') {
      navigate('/waiver');
    } else if (section === 'login') {
      navigate('/login');
    } else if (section === 'rental') {
      navigate('/rental');
    }
  };

  return (
    <div className="facility-rental-root">
      <LandingPageHeader onNav={handleNav} />
      
      <main className="facility-rental-content">
        <h1 className="facility-rental-title">FACILITY RENTAL</h1>
        
        {/* Book Your Spot Section */}
        <section className="book-spot-section">
          <div className="book-spot-card">
            <h2>Ready to Book?</h2>
            <p className="book-spot-message">
              To reserve your spot, please <strong>register</strong> for an account or <strong>log in</strong> if you already have one.  It is super easy!
            </p>
            <div className="book-spot-actions">
              <button className="book-action-btn register-btn" onClick={() => navigate('/register')}>
                Register
              </button>
              <button className="book-action-btn login-btn" onClick={() => navigate('/login')}>
                Log In
              </button>
            </div>
          </div>
        </section>

        {/* Availability Calendar */}
        <section className="calendar-section">
          <h2 className="calendar-section-title">Current Availability</h2>
          <PublicCalendar />
        </section>

        {/* Individual Batting Cage Rental Section */}
        <section className="batting-cage-section">
          <h2 className="batting-cage-title">INDIVIDUAL BATTING CAGE RENTAL</h2>
          <div className="batting-cage-content">
            <img 
              className="batting-cage-img" 
              src={process.env.PUBLIC_URL + '/batting-cage-rental.JPG'} 
              alt="Batting Cage" 
            />
            <div className="batting-cage-info">
              <h3>Info &amp; Pricing</h3>
              <p>
                $25 per hour. 1 hr. Minimum Rental; half-hour blocks can be added to the end of a 1hr rental at $15 per half hour.
              </p>
              <p>Waivers required to be completed prior to using cages.</p>
              <p className="available-label">Available at facility:</p>
              <ul>
                <li>Tees</li>
                <li>Pitching mats and mounds</li>
                <li>Z screens</li>
              </ul>
              <p className="sport-label">Baseball</p>
              <ul>
                <li>Hack attack Jr. with auto feeder option</li>
              </ul>
              <p className="sport-label">Softball</p>
              <ul>
                <li>Jugs wheel machine</li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="facility-rental-footer">
        <div className="footer-social">
          <a href="https://facebook.com/grangersportscomplex" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#27304b">
              <path d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z"/>
            </svg>
          </a>
        </div>
        <div className="footer-bottom">
          <span className="footer-copyright">COPYRIGHT © 2025 GRANGER SPORTS COMPLEX - ALL RIGHTS RESERVED.</span>
          <span className="footer-powered">POWERED BY <strong>GoDaddy Airo</strong></span>
        </div>
        <nav className="footer-nav">
          <button onClick={() => handleNav('home')}>Home</button>
          <button onClick={() => handleNav('rental')}>Facility Rental</button>
          <button onClick={() => handleNav('waiver')}>Participant waiver</button>
        </nav>
      </footer>
    </div>
  );
}

export default FacilityRental;
